var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOlympicFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.777 21.8a10.186 10.186 0 0 0 .772-6.41 12 12 0 0 0-3.083-5.74 16 16 0 0 1-3.574-4.314C23.962 3.362 25.7 1 25.7 1a8.73 8.73 0 0 0-1.605 1.053 6.1 6.1 0 0 0-2.181 3.2 6.3 6.3 0 0 0 .395 4.1 3.461 3.461 0 0 1 .557 1.378 5.113 5.113 0 0 0-1.683-1.71 4.849 4.849 0 0 0-3.5-.534 3.238 3.238 0 0 1 2.18 1.944c.518 1.531.252 2.438-.738 4.112-.9 1.532-1.335 3.707.417 5.079a4.14 4.14 0 0 1-3.189-1.895A6.561 6.561 0 0 0 18.18 23.4h11.537a8.029 8.029 0 0 0 1.06-1.6zM18.253 25.399v3.23h2.945L22.074 47h3.852l.876-18.371h2.945v-3.23z",
    fill: "var(--primary-color)",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlympicFlame);
export default __webpack_public_path__ + "static/media/olympic-flame.cb3d0786a86b43811a0d20e514da99fc.svg";
export { ForwardRef as ReactComponent };